/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_New_Guide_TitleInputs */

const en_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New KNP Guide`)
};

const fr_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau guide KNP`)
};

const de_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer KNP-Führer`)
};

const it_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova guida KNP`)
};

const ru_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый путеводитель по КНП`)
};

const es_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva guía del KNP`)
};

const zh_cn2_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新克鲁格国家公园指南`)
};

const ja_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいKNPガイド`)
};

const hi_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई केएनपी गाइड`)
};

const pt_pt2_knp_manager_new_guide_title = /** @type {(inputs: Knp_Manager_New_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo guia do Parque Nacional Kruger`)
};

/**
* | output |
* | --- |
* | "New KNP Guide" |
*
* @param {Knp_Manager_New_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_new_guide_title = /** @type {((inputs?: Knp_Manager_New_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_New_Guide_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_new_guide_title(inputs)
	if (locale === "de") return de_knp_manager_new_guide_title(inputs)
	if (locale === "it") return it_knp_manager_new_guide_title(inputs)
	if (locale === "ru") return ru_knp_manager_new_guide_title(inputs)
	if (locale === "es") return es_knp_manager_new_guide_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_new_guide_title(inputs)
	if (locale === "ja") return ja_knp_manager_new_guide_title(inputs)
	if (locale === "hi") return hi_knp_manager_new_guide_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_new_guide_title(inputs)
	return en_knp_manager_new_guide_title(inputs)
});